/**
 * @link https://mui.com/material-ui/react-radio-button/
 */

import {
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup, Typography,
} from "@mui/material";
import React from "react";
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeRadiogroup() {
  return (
    <>
      <FormControl>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="milling"
          name="radio-buttons-group"
          sx={{paddingLeft: '3px'}} >
          <FormControlLabel value="milling" control={<Radio />} label="small (default)" />
          <FormControlLabel value="turning" control={<Radio size="medium" />} label="medium" />
          {/* <FormControlLabel value="processing" control={<Radio size="large" />} label="large" /> */}
        </RadioGroup>
      </FormControl>
      <br/>
      <br/>

      <Divider textAlign={"left"}><Typography variant={"h6"}>Radiogroup as column</Typography></Divider>

      <FormControl>
        <FormLabel id="demo-radio-buttons-group-label" sx={{marginBottom: '4px'}}>Manufacturing process:</FormLabel>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="milling"
          name="radio-buttons-group"
          sx={{paddingLeft: '3px'}} >
          <FormControlLabel value="milling" control={<Radio />} label="CNC milling" />
          <FormControlLabel value="turning" control={<Radio />} label="CNC turning" />
          <FormControlLabel value="processing" control={<Radio />} label="CNC sheet metal processing" />
        </RadioGroup>
      </FormControl>
      <br/>
      <br/>

      <Divider textAlign={"left"}><Typography variant={"h6"}>Radiogroup in a row</Typography></Divider>

      <FormControl>
        <RadioGroup
          row
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="milling"
          name="radio-buttons-group"
          sx={{paddingLeft: '3px'}} >
          <FormControlLabel value="milling" control={<Radio />} label="CNC milling" sx={{marginRight: '1.5rem'}}/>
          <FormControlLabel value="turning" control={<Radio />} label="CNC turning" sx={{marginRight: '1.5rem'}}/>
          <FormControlLabel value="processing" control={<Radio />} label="CNC sheet metal processing" />
        </RadioGroup>
      </FormControl>
      <br/>
      <br/>
      
      <ShowCode 
        codeString={`<>
  {/* Basic RadioGroup with different sized Radio buttons */}
  <FormControl>
    <RadioGroup
      defaultValue="option1"
      name="radio-buttons-group"
    >
      <FormControlLabel value="option1" control={<Radio />} label="Default size" />
      <FormControlLabel value="option2" control={<Radio size="medium" />} label="Medium size" />
    </RadioGroup>
  </FormControl>
  
  {/* RadioGroup with FormLabel */}
  <FormControl>
    <FormLabel id="demo-radio-buttons-group-label">Select an option:</FormLabel>
    <RadioGroup
      aria-labelledby="demo-radio-buttons-group-label"
      defaultValue="option1"
      name="radio-buttons-group"
    >
      <FormControlLabel value="option1" control={<Radio />} label="Option 1" />
      <FormControlLabel value="option2" control={<Radio />} label="Option 2" />
      <FormControlLabel value="option3" control={<Radio />} label="Option 3" />
    </RadioGroup>
  </FormControl>
  
  {/* RadioGroup in a row */}
  <FormControl>
    <FormLabel id="demo-row-radio-buttons-group-label">Row layout:</FormLabel>
    <RadioGroup
      row
      aria-labelledby="demo-row-radio-buttons-group-label"
      defaultValue="option1"
      name="row-radio-buttons-group"
    >
      <FormControlLabel value="option1" control={<Radio />} label="Option 1" />
      <FormControlLabel value="option2" control={<Radio />} label="Option 2" />
      <FormControlLabel value="option3" control={<Radio />} label="Option 3" />
    </RadioGroup>
  </FormControl>
</>`} 
        scope={{ 
          React, 
          FormControl, 
          FormControlLabel, 
          FormLabel, 
          Radio, 
          RadioGroup 
        }} 
      />
    </>
  )
}